import { ArrowUpRight } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { PHOTO_SIZES, PHOTOS } from "./images";
import { BOOKING_URL, ROOMS_PATH, routeTo, TOUR_360_URL } from "@/lib/site";
import { TrustStrip } from "./TrustStrip";

export function Hero() {
  const photo = PHOTOS.rvSite;

  return (
    <section
      className="relative isolate bg-forest-deep pb-16 sm:pb-20 lg:pb-24"
      aria-labelledby="hero-title"
    >
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <img
          src={photo.src}
          srcSet={photo.srcSet}
          sizes={PHOTO_SIZES.fullBleed}
          alt={photo.alt}
          width={photo.width}
          height={photo.height}
          fetchPriority="high"
          decoding="async"
          className="hero-zoom size-full object-cover"
        />
        <div
          className="absolute inset-0 bg-[linear-gradient(180deg,oklch(0.259_0.042_163.6/0.88)_0%,oklch(0.259_0.042_163.6/0.62)_38%,oklch(0.259_0.042_163.6/0.9)_100%)]"
          aria-hidden="true"
        />
      </div>

      <div className="mx-auto max-w-[1400px] px-4 pt-16 sm:px-6 sm:pt-24 lg:px-10 lg:pt-32">
        <div className="hero-stagger max-w-3xl">
          <p className="eyebrow text-sand" style={{ "--stagger": 0 } as React.CSSProperties}>
            Your South Texas Destination
          </p>

          <h1
            id="hero-title"
            className="mt-5 text-balance font-display text-4xl leading-[1.05] text-cream sm:text-5xl lg:text-[4.1rem]"
            style={{ "--stagger": 1 } as React.CSSProperties}
          >
            Year-Round RV Camping &amp; Comfortable Stays in Zapata, Texas
          </h1>

          <p
            className="mt-6 max-w-2xl text-base leading-relaxed text-cream/85 sm:text-lg"
            style={{ "--stagger": 2 } as React.CSSProperties}
          >
            Settle in near Falcon Lake with full-hookup RV sites, cabins, motel rooms, tent camping,
            and the down-home hospitality Amigo Inn is known for.
          </p>

          <div
            className="mt-9 flex flex-wrap items-center gap-4"
            style={{ "--stagger": 3 } as React.CSSProperties}
          >
            <Button asChild variant="book" size="ctaLg">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
                Check Availability <ArrowUpRight aria-hidden="true" />
              </a>
            </Button>
            <Button asChild variant="outlineLight" size="ctaLg">
              <Link to={routeTo(ROOMS_PATH)}>Explore Sites &amp; Rooms</Link>
            </Button>
            {/* TODO: verify 360° tour URL before production deployment */}
            <a
              href={TOUR_360_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="link-underline text-sm font-semibold text-sand"
            >
              Take the 360° Tour <ArrowUpRight className="size-4" aria-hidden="true" />
            </a>
          </div>

          <div className="mt-12" style={{ "--stagger": 4 } as React.CSSProperties}>
            <TrustStrip />
          </div>
        </div>
      </div>
    </section>
  );
}
